import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

const PERIODS = [["month", "This month"], ["30d", "Last 30 days"], ["all", "All time"]];
const usd = (n) => `$${Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

const Stat = ({ label, value, sub, testId }) => (
  <div className="rounded-lg border border-[#2a2a2a] p-3" data-testid={testId}>
    <p className="text-[10px] font-extrabold tracking-[1.5px] text-neutral-400">{label}</p>
    <p className="mt-1 text-xl font-extrabold text-white">{value}</p>
    {sub && <p className="text-[11px] text-neutral-400">{sub}</p>}
  </div>
);

export const AdminShopSummary = () => {
  const navigate = useNavigate();
  const [period, setPeriod] = useState("month");
  const [d, setD] = useState(null);
  useEffect(() => { setD(null); api(`/public-store/admin/summary?period=${period}`).then(setD).catch(() => setD(false)); }, [period]);
  if (d === false) return null;
  return (
    <div data-testid="admin-shop-summary" className="mb-6 rounded-xl border border-[#333] bg-[#141414] p-4">
      <div className="mb-3 flex flex-wrap items-center gap-2">
        <span className="mr-auto w-full text-[11px] font-extrabold tracking-[2px] text-[#4CCC06] sm:w-auto">STORE SALES</span>
        {PERIODS.map(([k, l]) => <button key={k} onClick={() => setPeriod(k)} data-testid={`shop-summary-period-${k}`}
          className={`rounded-full px-2.5 py-1 text-[11px] font-bold transition-colors ${period === k ? "bg-[#4CCC06] text-black" : "text-neutral-400 hover:text-white"}`}>{l}</button>)}
      </div>
      {!d ? <p className="text-sm text-neutral-400">Loading…</p> : (
        <div className="grid grid-cols-2 gap-2 lg:grid-cols-4">
          <Stat testId="shop-summary-public" label="PUBLIC SHOP" value={usd(d.public.revenue_usd)} sub={`${d.public.orders} paid order${d.public.orders === 1 ? "" : "s"} · ${usd(d.public.card_fees_usd)} card fees`} />
          <Stat testId="shop-summary-portal" label="FRANCHISEE STORE (CARD)" value={usd(d.portal_paid.revenue_usd)} sub={`${d.portal_paid.orders} paid order${d.portal_paid.orders === 1 ? "" : "s"}`} />
          <Stat testId="shop-summary-invoiced" label="FRANCHISEE STORE (INVOICE)" value={usd(d.portal_invoiced.revenue_usd)} sub={`${d.portal_invoiced.orders} invoice order${d.portal_invoiced.orders === 1 ? "" : "s"}`} />
          <Stat testId="shop-summary-quotes" label="MACHINE REQUESTS" value={d.quotes.total} sub={`${d.quotes.wire} wire · ${d.quotes.total - d.quotes.wire} quote`} />
        </div>
      )}
      <button onClick={() => navigate("/admin/public-store")} data-testid="shop-summary-open" className="mt-3 text-[11px] font-extrabold text-[#4CCC06]">Open public store →</button>
    </div>
  );
};
